import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, styled, Typography } from '@mui/material'
import { visuallyHidden } from '@mui/utils'
import type { FC, PropsWithChildren } from 'react'

import { ICONS, remUnit, unit, COLORS } from '@hcr/ui'

interface NavigationAccountButtonProps extends PropsWithChildren {
  hoverColor: string
  isVisible: boolean
  pressedColor: string
  screenReaderPhase: string
  setIsVisible: (isVisible: boolean) => void
  standardColor: string
}

export const NavigationAccountButtonWrapper: FC<NavigationAccountButtonProps> = ({
  children,
  hoverColor,
  isVisible,
  pressedColor,
  screenReaderPhase,
  setIsVisible,
  standardColor,
}) => {
  return (
    <AccountButtonWrapper
      sx={{ color: isVisible ? pressedColor : standardColor, '&:hover': { color: hoverColor } }}
      onClick={() => setIsVisible(!isVisible)}
    >
      <AccountIcon $color={{ hoverColor, standardColor }}>
        <FontAwesomeIcon icon={ICONS.farCircleUser} />
      </AccountIcon>
      <Typography variant='bodyS' sx={visuallyHidden}>
        {screenReaderPhase}
      </Typography>
      {children}
    </AccountButtonWrapper>
  )
}

const AccountIcon = styled(Box, { shouldForwardProp: prop => prop !== '$color' })<{
  $color: { hoverColor: string; standardColor: string }
}>`
  aria-hidden: true;
  font-size: ${remUnit(5.5)};
  font-weight: initial;
  width: ${remUnit(5.5)};
  height: ${remUnit(6)};
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${unit(4)};

  * .fa-circle-user {
    aria-hidden: true;
    width: ${remUnit(5.5)};
    height: ${remUnit(6)};
    color: ${({ $color }) => $color.standardColor};
    .hover {
      color: ${({ $color }) => $color.hoverColor};
    }
  }
`

const AccountButtonWrapper = styled(Button)`
  display: inline-flex;
  gap: ${remUnit(1.5)};
  font-size: ${remUnit(3)};
  line-height: ${remUnit(6)};
  font-weight: medium;
  width: fit-content;
  padding: ${unit(2.5)} ${unit(3.5)} ${unit(2.5)} ${unit(3.5)};
  justify-content: space-between;
  text-transform: uppercase;
  line-height: ${remUnit(6)};

  :focus-visible {
    outline: ${unit(1)} solid ${COLORS.white} !important;
    outline-offset: ${unit(0.5)} !important;
  }

  .mobile-text {
    display: inline;
  }
  .login-text {
    display: none;
  }
  .desktop-text {
    display: none;
  }

  @media (min-width: ${props => props.theme.breakpoints.values['md']}px) {
    .mobile-text {
      display: none;
    }
    .desktop-text {
      display: inline;
    }
    .login-text {
      display: inline;
    }
  }
` as typeof Button
